<div class="trucking-component">
  <div class="heading flex flex-row justify-between">
    <h2 class="text-white">Trailer Management</h2>
  </div>

  <sa-subnav class="subnav" [subnavMenu]="subnavMenu" (onTabSwitch)="activeMenu = $event"></sa-subnav>

  <div class="content" *ngIf="activeMenu === subnavLabels.active">
    <div class="contracts">
      <sa-trailer-management-active
        [trailers]="activeTrailers$"
        [trailerTypes]="trailerTypes$"
        [subcarriers]="subcarriers$"
        [canManageTrailerManagement]="canManageTrailerManagement$"
      >
      </sa-trailer-management-active>
    </div>
  </div>

  <div class="content" *ngIf="activeMenu === subnavLabels.archived">
    <div class="contracts">
      <sa-trailer-management-archived
        [trailers]="archivedTrailers$"
        [trailerTypes]="trailerTypes$"
        [subcarriers]="subcarriers$"
        [canManageTrailerManagement]="canManageTrailerManagement$"
      >
      </sa-trailer-management-archived>
    </div>
  </div>
</div>
